import React, { useEffect, useState } from "react";
import { PageHeader } from "../../SharedComponents/PageHeader";

export const ExpectionsOrRejectionsBI = () => {
  return (
    <div
      className="row"
      style={{
        minHeight: "calc(100vh - 2rem - 56px)",
        backgroundColor: "white",
        marginRight: 0,
        marginLeft: 0,
        alignItems: "center",
      }}
    >
      <iframe
        title="Exceptions"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=abd33329-6cda-4f17-aae6-f0d04ae662fc&autoAuth=true&ctid=edb0e2ad-5f7b-4fcf-bbd2-7425af181ad1"
        frameBorder="0"
        allowFullScreen
        style={{
          minHeight: "calc(100vh - 2rem - 56px)",
        }}
      ></iframe>
    </div>
  );
};
